import { render, staticRenderFns } from "./Gurubets.vue?vue&type=template&id=356e66c8&scoped=true"
import script from "./Gurubets.vue?vue&type=script&lang=js"
export * from "./Gurubets.vue?vue&type=script&lang=js"
import style0 from "./Gurubets.vue?vue&type=style&index=0&id=356e66c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e66c8",
  null
  
)

export default component.exports